import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ErrorHandlerService } from '@aveva/connect-web-core';
import { firstValueFrom } from 'rxjs';
import { Import } from 'src/app/models/import.model';
import { Student } from 'src/app/models/student.model';
import { ImportsService } from 'src/app/services/imports.service';
import { StudentsService } from 'src/app/services/students.service';
import * as globals from '../../globals';
import { LoggingService } from '../../../services/logging.service';

@Component({
  standalone: false,
  selector: 'app-import-errors',
  templateUrl: './import-errors.component.html',
  styleUrls: ['./import-errors.component.scss']
})
export class ImportErrorsComponent {

  constructor(
    private dialogRef: MatDialogRef<ImportErrorsComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private errorHandler: ErrorHandlerService,
    private importsService: ImportsService,    
    private studentsService: StudentsService,
    private logger: LoggingService ) {
    this.importId = this.data.importId;
    this.studentId = this.data.studentId;
    this.errorMessage = this.data.errorMessage;

    try {
      if(this.importId === undefined || this.importId === null || this.importId === 0)
      {
        if(this.studentId === undefined || this.studentId === null || this.studentId === 0) {
          const errorMessages = this.errorMessage.split('|');
          this.filename = errorMessages[0];
          this.errors = errorMessages[1].split(',');
        }
        else {
          this.getStudentRecord()
            .then(studentObj => {
              this.errors = studentObj.errors.split(',');
              this.filename = `${globals.student} - ${studentObj.email_id}`;
            });
        }
      }
      else {
        this.title = 'Report';
        this.getImportRecord()
          .then(importObj => {
            this.errors = importObj?.errors[0]?.split(';');
            this.filename = importObj.filename;
          });
      }
    }
    catch {}
  }

  async getImportRecord(): Promise<Import> {
    this.isLoading = true;
    try {
      const data = await firstValueFrom(this.importsService.getImport(this.importId));
      this.logger.logEvent('Import Record Fetch Success', {importId: this.importId});
      this.isLoading = false;
      return data;
    } catch (error) {
      this.logger.logException(error);
      await this.errorHandler.handle(error);
      this.isLoading = false;
    }
  }

  async getStudentRecord(): Promise<Student> {
    this.isLoading = true;
    try {
      const data = await firstValueFrom(this.studentsService.getStudentById(this.studentId));
      this.logger.logEvent('Student Record Fetch Success', { studentId: this.studentId });
      this.isLoading = false;
      return data;
    } catch (error) {
      this.logger.logException(error);
      await this.errorHandler.handle(error);
      this.isLoading = false;
    }
  }

  ok = () => this.dialogRef.close(true);

  studentId: number;
  importId: number;
  filename: string;
  errors: string[];
  errorMessage: string;
  title: string = 'Errors';
  isLoading: boolean;
}
